import {Constants} from "@/constant/Constants";
import {SelectData} from "@/data/SelectData";
import { EnvironmentType } from '@/types';

export class Environment extends SelectData{
    private _serverAddress: string;
    private _clientAddress: string;

    constructor(data: EnvironmentType) {
        super();
        this._name = data[Constants.NAME];
        this._id = data[Constants.NAME];
        this._serverAddress = data[Constants.SERVER_ADDRESS];
        this._clientAddress = data[Constants.CLIENT_ADDRESS];
    }

    get serverAddress(): string {
        return this._serverAddress;
    }

    get clientAddress(): string {
        return this._clientAddress;
    }
}